import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

// Bajo demanda y al ARCHIVO, no al barrel, para que la pantalla viva en su propio chunk.
const TransferNotesSkPage = lazy(() =>
    import('@/domains/transferNotes/TransferNotesSkPage').then((m) => ({
        default: m.TransferNotesSkPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section`.
export const Route = createFileRoute('/_backoffice/credit/transfers')({
    component: CreditTransfers,
});

function CreditTransfers() {
    return (
        <Suspense fallback={<Loading fullScreen={false} className="py-16" />}>
            <TransferNotesSkPage />
        </Suspense>
    );
}
